export default (el, _directive, { cleanup }) => {
  const update = () => {
    const atBottom =
      el.scrollTop + el.clientHeight >= el.scrollHeight - 1
    const overflowing = el.scrollHeight > el.clientHeight && !atBottom
    el.toggleAttribute('data-scroll-fade', overflowing)
  }

  const observer = new ResizeObserver(update)
  observer.observe(el)
  el.addEventListener('scroll', update, { passive: true })
  update()

  cleanup(() => {
    observer.disconnect()
    el.removeEventListener('scroll', update)
  })
}
